import gql from "graphql-tag";

export const MY_HR_USER_ROLES_DATA_BY_CONTRACT_SUBSCRIPTION = gql`
  subscription userRolesDataByContract($contract: String!) {
    userRolesDataByContract(contract: $contract) {
      id
      roleId
      contract
      product
      role
      roleFilters {
        company
        orgUnit
        workingPlace
        jobClassGroup
        payOffice
        contract
      }
    }
  }
`;
